import falBackgroundRemovalModelBriaRmbg2 from './Schema/fal-background-removal-model_bria-rmbg2'
import falUpscaleModelSeedvr2 from './Schema/fal-upscale-model_seedvr2'
import fluxImageEditModelFlux2Pro from './Schema/flux-image-edit-model_flux2-pro'
import fluxInpaintModelFlux1Fill from './Schema/flux-inpaint-model_flux1-fill'
import fluxMultiImageEditModelFlux2Pro from './Schema/flux-multi-image-edit-model_flux2-pro'
import fluxSimilarToModelFlux2Pro from './Schema/flux-similar-to-model_flux2-pro'
import fluxTextToImageModelFlux2Pro from './Schema/flux-text-to-image-model_flux2-pro'
import nanoBananaImageEditModelNb2Lite from './Schema/nano-banana-image-edit-model_nb2-lite'
import nanoBananaMultiImageEditModelNb2Lite from './Schema/nano-banana-multi-image-edit-model_nb2-lite'
import nanoBananaSimilarToModelNb2Lite from './Schema/nano-banana-similar-to-model_nb2-lite'
import nanoBananaTextToImageModelNb2Lite from './Schema/nano-banana-text-to-image-model_nb2-lite'

// The image counterpart of MODEL_SOURCES. Unlike the 3D schemas these carry no property
// defaults: a run sent without the composer settings must keep sending only what the
// user provided, so the backend catalog's defaults (auto aspect ratio, one image) apply.
//
// Order matters within an action: imageSchemaFor falls back to the first schema offering
// the action when no provider is picked, which is when the backend ranks the providers
// itself. Nano Banana leads to match the composer's default model.
export const IMAGE_SOURCES = [
  nanoBananaTextToImageModelNb2Lite,
  nanoBananaSimilarToModelNb2Lite,
  nanoBananaImageEditModelNb2Lite,
  nanoBananaMultiImageEditModelNb2Lite,
  fluxTextToImageModelFlux2Pro,
  fluxSimilarToModelFlux2Pro,
  fluxImageEditModelFlux2Pro,
  fluxMultiImageEditModelFlux2Pro,
  fluxInpaintModelFlux1Fill,
  falBackgroundRemovalModelBriaRmbg2,
  falUpscaleModelSeedvr2,
]
